const useCompanyUserPermissionsList = (permissionsGroup,
  studioPermissionsToIterate) => {
  const studioPermissionsToIterate1 = studioPermissionsToIterate[1];
  const studioPermissionsToIterate2 = studioPermissionsToIterate[3];
  const studioPermissionsToIterate3 = studioPermissionsToIterate[0];
  const studioPermissionsToIterate4 = studioPermissionsToIterate[9];
  const studioPermissionsToIterate5 = studioPermissionsToIterate[4];

  const group1 = permissionsGroup.filter(g => g.groupId === "2");
  const group2 = permissionsGroup.filter(g => g.groupId === "1");
  const group3 = permissionsGroup.filter(g => g.groupId === "15");
  const group4 = permissionsGroup.filter(g => g.groupId === "6");
  const group5 = permissionsGroup.filter(g => g.groupId === "7");

  const permissionsList1 = group1[0].permissions;
  const permissionsList2 = group4[0].permissions;
  const permissionsList3 = group2[0].permissions;
  const permissionsList4 = group3[0].permissions;
  const permissionsList5 = group5[0].permissions;

  const permissionsList1WithCompanyRaw = permissionsList1.map(perm => {
    return studioPermissionsToIterate1.map(stPerm => {
      if (perm.functionId === stPerm.functionId) {
        return {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList2WithCompanyRaw = permissionsList2.map(perm => {
    return studioPermissionsToIterate2.map(stPerm => {
      if (perm.functionId === stPerm.functionId) {
        return {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList3WithCompanyRaw = permissionsList3.map(perm => {
    return studioPermissionsToIterate3.map(stPerm => {
      if (perm.functionId === stPerm.functionId) {
        return {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList4WithCompanyRaw = permissionsList4.map(perm => {
    return studioPermissionsToIterate4.map(stPerm => {
      if (perm.functionId === stPerm.functionId) {
        return {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList5WithCompanyRaw = permissionsList5.map(perm => {
    return studioPermissionsToIterate5.map(stPerm => {
      if (perm.functionId === stPerm.functionId) {
        return {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });

  const permissionsList1WithCompany = permissionsList1WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList2WithCompany = permissionsList2WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList3WithCompany = permissionsList3WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList4WithCompany = permissionsList4WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList5WithCompany = permissionsList5WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });

  const permissionsListStructure = [
    {
      listToIterate: permissionsList1WithCompany,
      index: 1,
      listLabel: "permissionsList1"
    },
    {
      listToIterate: permissionsList5WithCompany,
      index: 4,
      listLabel: "permissionsList5"
    },
    {
      listToIterate: permissionsList2WithCompany,
      index: 3,
      listLabel: "permissionsList2"
    },
    {
      listToIterate: permissionsList3WithCompany,
      index: 0,
      listLabel: "permissionsList3"
    },
    {
      listToIterate: permissionsList4WithCompany,
      index: 9,
      listLabel: "permissionsList4"
    }
  ];
  return permissionsListStructure;
};

export default useCompanyUserPermissionsList;
